import $ from "jquery";

import SyncableModel from "shared/syncable_model";

import _ from "underscore";

export default class VirtualLine extends SyncableModel {
  toJSON() {
    return { owner: this.getOwner(), virtual_line: _.pick(this.attributes, this._permittedAttributesForSave()) };
  }

  validate() {
    this.unset("errors");
    const errors = {};

    if (this.isNew()) {
      this._validatePresenceOfOwner(errors);
      this._validatePresenceOfPromoType(errors);
    }

    if (!_.isEmpty(errors)) {
      this.set('errors', errors);
      return errors;
    }
  }

  _validatePresenceOfPromoType(errors) {
    const numberType = $.trim(this.get("promo_type"));
    if (numberType === "" || numberType === undefined) {
      errors.promo_type = "is required";
    }
  }

  getOwner() {
    let owner = this.get("owner");
    const advertiserCampaignId = this.get("advertiser_campaign_id");
    const affiliateCampaignId = this.get("affiliate_campaign_id");

    if (!owner && advertiserCampaignId) {
      if (affiliateCampaignId) {
        owner = `AffiliateCampaign_${affiliateCampaignId}`;
      } else {
        owner = `AdvertiserCampaign_${advertiserCampaignId}`;
      }
    }

    return owner;
  }

  _validatePresenceOfOwner(errors) {
    if (!this.getOwner()) {
      errors.advertiser_campaign_id = "is required";
    }
  }

  _permittedAttributesForSave() {
    const attributes = ['description', 'media_type', 'adwords_account_id'];
    if (this.isNew()) {
      return attributes.concat("number_pool_location", "number_pool_whitelist", "number_pool_search_radius", "promo_type", "promo_number_looks_like");
    } else {
      return attributes;
    }
  }
}
